import RestX from 'highered-utils/restx';
import i18n from '~/localization/i18n';

import URLS from '~/URLS';

// Custon dialogs
import UniversityVerifyDialog from '~/components/miscellaneous/VerifyModule.Dialog';
import LocalCompanyProfileDialog from '~/views/companydetail/components/LocalProfile.Dialog';
import ArticleDialog from '~/shared/ArticleDialog';
import CompanyArticleDialog from '~/views/companydetail/components/Articles.Dialog';
import VideoDialog from '~/components/miscellaneous/Video.Dialog';
import LocationAllDialog from '~/views/companydetail/components/Locations.All.Dialog';
import EducationDialog from '~/components/miscellaneous/EducationDialog';
import AssessmentConsentDialog from '~/views/assessmentscenter/components/AssessmentConsentDialog';
import AppointmentBookDialog from '~/views/calendar/appointment_book/components/AppointmentBook.Dialog';
import VideoChatInvitationDialog from '~/components/chat/VideoChatInvitation.Dialog.vue';
import VideoChatEmbedDialog from '~/components/chat/VideoChatEmbed.Dialog.vue';
import UploadCVDialog from '~/views/documents/components/UploadCVDialog.vue';
import ConsentDialog from '~/shared/UserConsent/ConsentDialog.vue';
import AddNameDialog from '~/components/miscellaneous/AddName.Dialog';
import VirtualEventPromotionDialog from '~/components/miscellaneous/VirtualEventPromotionDialog.vue';
import AddNewSchoolDialog from '~/components/miscellaneous/AddNewSchool.Dialog.vue';

// Services
import CandidateService from '~/services/CandidateServiceOld';
import CommunicationService from "~/services/CommunicationService";

class DialogService {

    static profileRequestPanel = undefined;

    // hasHistory() is a helper method that checks whether dialogModal has registered history that is traversible or not
    static hasHistory() {
        return RestX.getInterfaces().dialogModal.hasHistory();
    }

    static popState() {
        RestX.getInterfaces().dialogModal.popState();
    }

    static setTitle(title) {
        RestX.getInterfaces().dialogModal.setTitle(title);
    }

    static openVirtualEventPromotion(vfairId) {
        RestX.getInterfaces().dialogModal.openModal({
            component: VirtualEventPromotionDialog,
            props: {
                vFairId: vfairId,
            },
            clickawayOff: true,
            windowMode: true,
            listeners: {
                close() {
                    RestX.getInterfaces().dialogModal.getState().resolver.res();
                },
            },
        });
    }

    static openEducationDialog(props, listeners) {
        RestX.getInterfaces().dialogModal.openModal({
            component: EducationDialog,
            props: props,
            listeners: listeners,
            actions: [],
            clickawayOff: false,
            windowMode: true,
        });
    }

    static openAllLocationsDialog(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: LocationAllDialog,
            actions: [],
            clickawayOff: true,
            windowMode: true,
            payload: payload,
        });
    }

    static openLocalCompanyProfileDialog(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: LocalCompanyProfileDialog,
            actions: [],
            clickawayOff: true,
            // schoolBranding: true,
            windowMode: true,
            payload: payload,
        });
    }

    static openVideoDialog(payload, component) {
        RestX.getInterfaces().dialogModal.openModal({
            component: component || VideoDialog,
            actions: [],
            props: { videoLink: payload.videoLink },
            clickawayOff: true,
            windowMode: true,
            payload: payload,
        });
    }

    static openVideoChatDialog(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: VideoChatEmbedDialog,
            actions: [],
            props: payload,
            clickawayOff: true,
            windowMode: true,
            payload: payload,
        });
    }

    static openVideoChatDialogInvitation(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: VideoChatInvitationDialog,
            actions: [],
            props: payload,
            clickawayOff: true,
            windowMode: true,
            title: 'Video Chat Invitation',
            payload: payload,
        });
    }

    static openArticleDialog(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: ArticleDialog,
            props: {
                title: payload.title,
                body: payload.body,
                img: payload.img,
            },
            actions: [],
            clickawayOff: true,
            windowMode: true,
        });
    }

    static openCompanyArticleDialog(payload) {
        RestX.getInterfaces().dialogModal.openModal({
            component: CompanyArticleDialog,
            actions: [],
            props: { videoLink: payload.videoLink },
            clickawayOff: true,
            windowMode: true,
            payload: payload,
        });
    }

    static openUniVerifyDialog(config) {
        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('components.miscellaneous.verifyModule.title'),
            component: UniversityVerifyDialog,
            actions: [],
            clickawayOff: true,
            ...config,
        });
    }

    static openAddNewSchoolDialog(config) {
        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('components.miscellaneous.addNewSchoolDialog.title'),
            component: AddNewSchoolDialog,
            clickawayOff: true,
            ...config,
        });
    }

    static openAssessmentConsentDialog(aonContext, listeners = {}) {
        RestX.getInterfaces().dialogModal.openModal({
            component: AssessmentConsentDialog,
            actions: [],
            props: { context: aonContext },
            listeners: listeners,
            clickawayOff: false,
            windowMode: true,
        });
    }

    static openUploadCVDialog(file, listeners) {
        RestX.getInterfaces().dialogModal.openModal({
            component: UploadCVDialog,
            actions: [],
            clickawayOff: false,
            windowMode: true,
            listeners: listeners,
            props: {
                file: file,
            },
        });
    }

    static openEditCVDialog(cv, listeners) {
        RestX.getInterfaces().dialogModal.openModal({
            component: UploadCVDialog,
            actions: [],
            clickawayOff: false,
            windowMode: true,
            listeners: listeners,
            props: {
                cv: cv,
            },
        });
    }

    static openAppointmentBookingDialog(notification, type) {
        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('calendar.bookModal.title'),
            component: AppointmentBookDialog,
            actions: [],
            clickawayOff: false,
            props: {
                ...notification,
                type,
            },
        });
    }

    static openAppointmentDeleteBookingDialog(onCancel, onDelete) {
        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('calendar.deleteBookModal.title'),
            content: i18n.t('calendar.deleteBookModal.content'),
            clickawayOff: false,
            actions: [
                {
                    title: i18n.t('calendar.deleteBookModal.cancel'),
                    variant: 'primary',
                    action: onCancel,
                },
                {
                    title: i18n.t('calendar.deleteBookModal.delete'),
                    variant: 'secondary',
                    action: onDelete,
                },
            ],
        });
    }

    static openAddNameDialog(routerObject) {
        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('components.miscellaneous.addNameDialog.title'),
            component: AddNameDialog,
            actions: [
                {
                    title: i18n.t('general.ok'),
                    variant: 'primary',
                    action: ({ res }) => res(),
                },
            ],
            clickawayOff: true,
            then: () => routerObject.push(URLS.spotlight),
        });
    }

    static destroyProfilerSharingConfirmationPanel() {
        if (DialogService.profileRequestPanel) {
            top.removeEventListener('message', DialogService.profileRequestPanel.handler);
            DialogService.profileRequestPanel.panel.destroy();
            DialogService.profileRequestPanel = undefined;
        }
    }

    static openProfileSharingConfirmationPanel(inbox, conversation, name, profileSharingConsent, onConfirm, onReject, env) {
        DialogService.destroyProfilerSharingConfirmationPanel(inbox);
        const title = encodeURIComponent(i18n.t('chat.profileSharingConfirmDialog.title', { name: name }));
        const reject = encodeURIComponent(i18n.t('chat.profileSharingConfirmDialog.reject'));
        const accept = encodeURIComponent(i18n.t('chat.profileSharingConfirmDialog.share'));
        setTimeout(() => {
            inbox.createHtmlPanel({
                url: `${env.VUE_APP_CDN_URL}/profile-request-panel.html?title=${title}&accept=${accept}&reject=${reject}`,
                show: true,
            }).then((htmlPanel) => {
                const acceptRejectButtonListener = (event) => {
                    if (event.data === 'accept-profile-request') {
                        CandidateService.answerProfileSharingRequest(profileSharingConsent.id, true).then(onConfirm);
                        DialogService.destroyProfilerSharingConfirmationPanel(inbox);
                        CommunicationService.setConversationMetadata(conversation.id, {profileRequestPanelOpened: ''});
                    } else if (event.data === 'reject-profile-request') {
                        CandidateService.answerProfileSharingRequest(profileSharingConsent.id, false).then(onReject);
                        DialogService.destroyProfilerSharingConfirmationPanel(inbox);
                        CommunicationService.setConversationMetadata(conversation.id, {profileRequestPanelOpened: ''});
                    }
                };
                top.addEventListener('message', acceptRejectButtonListener);
                const panelInfo = {panel: htmlPanel, handler: acceptRejectButtonListener};
                DialogService.profileRequestPanel = panelInfo;
                CommunicationService.setConversationMetadata(conversation.id, {profileRequestPanelOpened: 'yes', profileRequestPanelUser: '' + name, profileRequestPanelConsent: JSON.stringify(profileSharingConsent)});
            });
        });
    }

    static openProfileSharingConfirmationDialog(name, profileSharingConsent, onConfirm, onReject) {
        const closeAction = ({ res, rej }) => {
            CandidateService.answerProfileSharingRequest(profileSharingConsent.id, false)
                .then(onReject)
                .then(res)
                .catch(rej);
        };

        const acceptAction = ({ res, rej }) => {
            CandidateService.answerProfileSharingRequest(profileSharingConsent.id, true)
                .then(onConfirm)
                .then(res)
                .catch(rej);
        };

        RestX.getInterfaces().dialogModal.openModal({
            title: i18n.t('chat.profileSharingConfirmDialog.title', { name: name }),
            content: i18n.t('chat.profileSharingConfirmDialog.content'),
            clickawayOff: false,
            actions: [
                {
                    title: i18n.t('chat.profileSharingConfirmDialog.share'),
                    variant: 'primary',
                    action: acceptAction,
                },
                {
                    title: i18n.t('chat.profileSharingConfirmDialog.reject'),
                    variant: 'secondary',
                    action: closeAction,
                },
            ],
        });
    }

    static openCookieConsentDialog() {
        RestX.getInterfaces().dialogModal.openModal({
            component: ConsentDialog,
            actions: [],
            clickawayOff: false,
            windowMode: true,
            then: () => {},
            error: () => {},
        });
    }

    /**
     *
     * @typedef {Object} ActionOptions
     * @property {string=} id
     * @property {string} title
     * @property {string} variant
     * @property {function} action
     *
     * @param {object} options
     * @param {string=} options.title
     * @param {string=} options.content
     * @param {any=} options.component
     * @param {Array<ActionOptions>=} options.actions
     * @param {object=} options.props
     * @param {boolean=} options.clickawayOff
     * @param {boolean=} options.windowMode
     * @param {function=} options.then
     * @param {function=} options.error
     * @param {any=} options.listeners
     */
    static openDialog(options) {
        RestX.getInterfaces().dialogModal.openModal({
            clickawayOff: false,
            ...(options || {}),
        });
    }

    static openErrorDialog(error) {
        if (!error) {
            return;
        }
        if (error instanceof Array && error.length > 0) {
            error = error[0];
        }

        // Build error message
        let message = `${i18n.t('general.error')}: ${error}`;
        let title = i18n.t('errors.defaultErrorMessage');

        switch (error) {
            case 'INVALID_PROVIDER_LINKEDIN':
                message = i18n.t('errors.socialAuthErrorText.invalidProvider');
                title = i18n.t('errors.socialAuthErrorText.errorTitle', {
                    provider: 'LinkedIn',
                });
                break;
            case 'INVALID_PROVIDER_FACEBOOK':
                message = i18n.t('errors.socialAuthErrorText.invalidProvider');
                title = i18n.t('errors.socialAuthErrorText.errorTitle', {
                    provider: 'Facebook',
                });
                break;
            case 'INVALID_PROVIDER_GOOGLE':
                message = i18n.t('errors.socialAuthErrorText.invalidProvider');
                title = i18n.t('errors.socialAuthErrorText.errorTitle', {
                    provider: 'Google',
                });
                break;
            case 'INVALID_PROVIDER_WECHAT':
                message = i18n.t('errors.socialAuthErrorText.invalidProvider');
                title = i18n.t('errors.socialAuthErrorText.errorTitle', {
                    provider: 'WeChat',
                });
                break;
        }

        RestX.getInterfaces().dialogModal.openModal({
            title: title,
            content: message,
            isError: true,
            clickawayOff: false,
            order: 300,
            actions: [
                {
                    title: i18n.t('general.ok'),
                    variant: 'secondary',
                    action: ({ res }) => res('close'),
                },
            ],
        });
    }
}

export default DialogService;
